export const useLocalStorage = () => {
  const retrieveLocalFinancialData = async (key) => {
    try {
      // Implement data retrieval logic here
      // For example, using local storage:
      const savedData = sessionStorage.getItem(key);
      return savedData ? JSON.parse(savedData) : null;
    } catch (error) {
      return null;
    }
  };
  const saveLocalFinancialData = async (key, data) => {
    try {
      // Implement data saving logic here
      // For example, using local storage:
      sessionStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch (error) {
      return false;
    }
  };
  return { retrieveLocalFinancialData, saveLocalFinancialData };
};
